import React from "react";
import { useSelector } from "react-redux";
import { Button, Header, Modal } from "semantic-ui-react";
import ConfirmInputModalAction from "@common/redux/actions/ConfirmInputModalAction";
import SimpleInputComponent from "../../common/components/shared/forms/SimpleInputComponent";

const ConfirmInputModal = (props) => {
  const { open, message, confirmInput } = useSelector((state) =>
    ConfirmInputModalAction.getStatePath(state),
  );

  const setState = (payload) => ConfirmInputModalAction.dispatch(payload);

  const onConfirm = () => {
    setState({ open: false, confirmInput: "" });
    ConfirmInputModalAction.onConfirm();
  };

  const onClose = () => {
    setState({ open: false, confirmInput: "" });
    ConfirmInputModalAction.onClose();
  };

  const onInputChange = (_, { name, value }) => setState({ [name]: value });

  return (
    <Modal open={open} onClose={onClose} closeIcon size="tiny">
      <Header>{props.header || "Confirmation"}</Header>
      <Modal.Content>
        <p>{message}</p>
        <SimpleInputComponent
          name="confirmInput"
          value={confirmInput}
          onChange={onInputChange}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onClose} negative>
          Cancel
        </Button>
        <Button
          disabled={confirmInput !== "DELETE"}
          onClick={onConfirm}
          positive
        >
          Submit
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default ConfirmInputModal;
